import apiHelperFinance from '@/services/helperFinance'
const createInvoice = async param => {
    try {
        let url = '/admin/invoice/create'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

/* const createInvoiceTong = async param => {
    try {
        let url = '/admin/invoice/create-test'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
} */

const getListInvoice = async param => {
    try {
        let url = '/admin/invoice/get-all'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const getListInvoiceAllDeleted = async param => {
    try {
        let url = '/admin/invoice/get-all-deleted'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const deleteInvoice = async param => {
    try {
        let url = '/admin/invoice/delete'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const getDetailError = async param => {
    try {
        let url = '/admin/invoice/get-detail-error'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getInvoiceById = async id => {
    try {
        let url = '/admin/invoice/get-detail?invoice_id=' + id
        // TODO response.data
        return (await apiHelperFinance.getWithFirebaseToken(url)).data
    } catch (error) {
        throw new Error(error)
    }
}

const updateInvoice = async param => {
    try {
        let url = '/admin/invoice/update'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getInvoiceOrderList = async param => {
    try {
        let url = '/admin/invoice/get-order-list'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const getExportExcel = async param => {
    try {
        let url = '/admin/invoice/export'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getExportsExcel = async param => {
    try {
        let url = '/admin/invoice/exports'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const createDetailOrder = async param => {
    try {
        let url = '/admin/invoice/create-detail'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const updateDetailOrder = async param => {
    try {
        let url = '/admin/invoice/update-detail'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const updateRunningNumber = async param => {
    try {
        let url = '/admin/invoice/update-running-number'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const clearRunning = async id => {
    try {
        let url = '/admin/payment/clear-date?date=' + id
        // TODO response.data
        return (await apiHelperFinance.getWithFirebaseToken(url)).data
    } catch (error) {
        throw new Error(error)
    }
}
const confirmPickup = async param => {
    try {
        let url = '/admin/invoice/confirm-pickup'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

/*
Invoice Flow
*/
const getUnbilledInvoiceBill = async param => {
    try {
        let url = '/admin/invoice/bill/get-unbilled'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const confirmInvoice = async param => {
    try {
        let url = '/admin/invoice/confirm'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const getOverdueUnbilledInvoiceBill = async param => {
    try {
        let url = '/admin/invoice/bill/get-overdue-unbilled'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getOnlineInvoiceBill = async param => {
    try {
        let url = '/admin/invoice/bill/get-online'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getPendingInvoiceBill = async param => {
    try {
        let url = '/admin/invoice/bill/get-pending'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getBilledInvoiceBill = async param => {
    try {
        let url = '/admin/invoice/bill/get-billed'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const changePending = async param => {
    try {
        let url = '/admin/invoice/bill/change-pending'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const changeReject = async param => {
    try {
        let url = '/admin/invoice/bill/reject'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const changeApprove = async param => {
    try {
        let url = '/admin/invoice/bill/approve'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
/*
End Invoice Flow
*/
export default {
    createInvoice,
    getListInvoice,
    getListInvoiceAllDeleted,
    deleteInvoice,
    getDetailError,
    getInvoiceById,
    updateInvoice,
    getInvoiceOrderList,
    getExportExcel,
    getExportsExcel,
    createDetailOrder,
    updateRunningNumber,
    updateDetailOrder,
    clearRunning,
    confirmPickup,
    // createInvoiceTong,
    confirmInvoice,
    getUnbilledInvoiceBill,
    getOverdueUnbilledInvoiceBill,
    getOnlineInvoiceBill,
    getPendingInvoiceBill,
    getBilledInvoiceBill,
    changePending,
    changeReject,
    changeApprove
}
